import contact from '../../api/contact.json' with { type: 'json' };

// 掲載原稿・画像・リンク・演出設定はここで管理する。
export const site = {
  name: 'F.F.D',
  logo: './assets/images/SVG/logo.svg',
  tagline: 'DESIGN & DEVELOPMENT',
  contactEmail: contact.recipient,
  intro: 'FFDは、神奈川県大和市を拠点に、Webサイト制作やECサイト構築、予約システムなどを、企画・設計からデザイン、開発まで手掛けるデザイン事務所です。',
  description: 'ホームページの新規制作・リニューアル、WordPress構築、LP制作に対応。事業の目的や日々の業務を伺い、情報設計・UI/UXデザインから実装、公開後の改善までお手伝いします。制作会社・広告代理店の制作パートナーとしてのご相談も承ります。',
  movie: { src: './assets/mov/1020.webm', fallbackSrc: './assets/mov/1020.mp4', poster: './assets/images/mv-poster.jpg', label: 'メインムービーエリア' },
  railMovie: { src: './assets/mov/Equalizer-300.webm', poster: './assets/images/creative-poster.webp' },
};

export const slideshow = {
  effect: 'polygons-fall',
  effects: [
    { id: 'polygons-fall', name: 'Polygons Fall' },
    { id: 'shards-fall', name: 'Shards Fall' },
    { id: 'flyeye', name: 'Flyeye' },
  ],
  interval: 6500,
  duration: 1600,
  strength: 0.055,
  frequency: 34,
  dispersion: 0.4,
  images: [
    { src: './assets/images/submv-uiux.png', annotated: false },
    { src: './assets/images/submv-robot.webp', annotated: true },
  ],
};

export const topics = [
  {
    id: 'about', title: '私たちは・・・',
    summary: '事業の目的や日々の業務を理解することから、デザイン、開発、公開後の改善まで。一つ一つの課題に向き合い、必要な形を作ります。',
    paragraphs: [
      'Web・EC・Webサービスの企画・設計から、デザイン、システム開発まで。「何をつくるか」の前に、「何のためにつくるか」を一緒に考えます。',
      '事業や業務を理解し、必要な情報と機能を整理。利用者と運用者の使いやすさ、裏側の仕組みまで考え、公開後の改善にも取り組みます。',
    ],
  },
  {
    id: 'ai', title: 'AI駆動開発について',
    summary: 'これまで培ってきた経験や技術にAIを組み合わせ、開発に必要な時間とコストを見直す。今まで予算や技術的な理由で提案が難しかったアイデアも、現実的な選択肢に変えていきます。',
    paragraphs: [
      '設計・開発の経験にAIを組み合わせ、調査・実装・検証を進めます。出力をそのまま使わず、目的や既存の仕組みとの整合性を人が確かめ、品質を整えます。',
      '必要な機能と優先順位を整理し、予算や運用に合う方法を選択。技術を目的にせず、実際に使える形につなげます。',
    ],
  },
  {
    id: 'ui', title: 'UI/UXについて',
    summary: '使う人が迷わず、運用する人にも負担をかけない。見た目の美しさだけでなく、情報の伝わり方、操作のしやすさを考え、心地よく使えるデザインを目指します。',
    paragraphs: [
      '必要な情報が見つかり、迷わず操作できること。情報の順序、文字の読みやすさ、ボタンの役割を考え、見た目と使う流れを一緒に設計します。',
      '利用者だけでなく、日々の更新・管理をする人にも目を向け、続けて使いやすい仕組みをつくります。',
    ],
  },
];

export const stages = [
  { id: 'planning', title: '要件定義', paragraphs: ['事業の目的、現在の課題、使う人のことを伺います。必要な情報や機能を整理し、何から取り組むかを一緒に考えます。', '制作する範囲と優先順位を明確にし、目的を共有するところから始めます。'] },
  { id: 'design', title: '設計', paragraphs: ['伝える情報と、利用する人の行動を整理して、画面の構成と操作の流れを設計します。', '見た目の美しさと分かりやすさをあわせて考え、途中の案を確認しながら具体化します。'] },
  { id: 'develop', title: '実装', paragraphs: ['設計した画面と使い方を、実際に動く機能として形にします。WebやECの構築から、業務に合わせたシステム開発まで対応します。', '情報を更新・管理する人の操作も考え、画面と仕組みを一緒につくります。'] },
  { id: 'improve', title: '改善', paragraphs: ['公開後に見えてきた課題や、日々の運用で気づいたことを伺います。', '情報の更新、画面や機能の見直しなど、合意した支援範囲で改善を続けます。'] },
];

// 最初の20vhは先頭を維持。その後はカード1枚分で端の抵抗から中央の等速へつなぐ。
export const processScroll = { startHoldVh: 20, edgeCards: 1, edgeResistance: 4 };
// スマホでは各カードの左揃え位置で画面高の18%分、横位置を保持する。
export const mobileScroll = { cardHoldVh: 18 };

export const approach = [
  { title: 'ヒアリング〜ディレクション', icon: 'herering', paragraphs: ['あなたの要望を詳しく理解し、事業や業務の整理から携わります。', 'そして、最適で必要な方向性のご提案をする。', 'それが私たちの使命です。'] },
  { title: '要件定義・情報設計', icon: 'youken', paragraphs: ['必要な機能や情報を整理し、目的に応じた要件を明確にします。', 'ユーザーの使いやすさと分かりやすさを考慮して、最適な情報構造をデザインします。'] },
  { title: 'デザイン〜UI/UX', icon: 'uiux', paragraphs: ['見た目の美しさだけでなく、使いやすさや心地よさを追求します。', '細部までこだわり、直感的でストレスのない体験をつくる。', 'それが私たちの目指すデザインです。'] },
  { title: '実装・システム開発', icon: 'creative_1', paragraphs: ['デザインで考えた使い方を、実際に動く機能へ。', 'WebサイトやECの構築から、業務に合わせた開発まで、更新・管理の仕方も考えて実装します。'] },
  { title: '公開後の運用・改善', icon: 'sastena_1', paragraphs: ['公開は、使われ方を確かめるスタートです。', '日々の運用で見えてくる課題を伺い、情報や機能を見直します。合意した支援範囲で、継続して改善に取り組みます。'] },
];

// スクロール確認用に右一覧の末尾へ追加する、内容なしの項目数。
export const workPlaceholders = 0;

export const services = [
  {
    id: 'stact', name: 'STACT', href: 'https://stact.jp/', linkLabel: 'STACTのサイトをみる', logo: { src: './assets/images/services/stact-logo.svg', width: 210, height: 50 }, category: '宿・体験・飲食店の総合管理システム',
    title: '予約も、運営も、ひとつに。',
    image: { src: './assets/images/services/stact-dashboard.webp', alt: 'STACT公式サイト掲載の予約管理カレンダー画面', width: 1260, height: 854 },
    paragraphs: [
      '宿泊施設・体験サービス・飲食店の予約や空き状況、在庫をまとめて管理。自社サイトでの予約受付からHangoutへの情報掲載まで対応します。',
      '予約ごとの手数料は0円。月額制で利用できる、事業者のための総合管理システムです。',
    ],
  },
  {
    id: 'hangout', name: 'Hangout', href: 'https://go-hangout.jp/', linkLabel: 'Hangoutのサイトをみる', logo: { src: './assets/images/services/hangout-logo.svg', width: 228.2, height: 58.9 }, category: '宿・体験・飲食店を探せるポータル',
    title: '「見つけた」を、「行きたい」に。',
    image: { src: './assets/images/hangout.webp', alt: 'タブレットで見るHangoutのポータル画面', width: 992, height: 992 },
    paragraphs: [
      '宿泊先や体験、飲食店との新しい出会いをつくるポータルサイト。',
      'STACTに登録された情報を利用者に届け、サービスの発見から予約リクエストへ。事業者と利用者をつなぐ、もうひとつの入口です。',
    ],
  },
  {
    id: 'reserve', name: 'Noteres', href: 'https://funkyfreshdesign.com/reserve/owner/dashboard/', linkLabel: 'デモをみる', image: { src: './assets/images/services/reserve.png', alt: 'Noteresの予約管理画面。担当者別タイムラインと予約一覧。', width: 3012, height: 1952 }, category: '歯科医院・サロンなどの専用予約システム',
    title: '紙に書くより簡単に',
    paragraphs: [
      '予約の取り方も、受付の流れも、現場によって違うもの。',
      'Noteresは、歯科医院やサロンなど、それぞれの業務に合わせて予約の仕組みを設計します。',
      '5分単位・担当者単位で予約を管理。複数の担当者を同時に予約することもでき、現場に合わせた柔軟な予約受付に対応します。',
      '予約する人にも、管理する人にも。無理なく使える、現場のための予約システムです。',
    ],
  },
];

export const works = [
  {
    id: 'tailorgarments', preview: './assets/mov/tailorgarments-scroll-960-20261023.webm', showcaseVideo: true, name: 'Tailorgarments', category: 'EC / Shopify', image: './assets/images/tailorgarments.webp', href: 'https://tailorgarments.jp/', description: 'デザイン・ディレクション・Shopify構築', featured: true,
    detail: 'AIを活用した採寸機能や、品番ごとに異なる生地選択を実装。LiquidとJavaScriptを組み合わせ、Shopifyの自由度を活かした購入体験を構築しています。',
    screenshots: [
      { src: './assets/images/works/tailorgarments-ai-measurement.png', alt: 'TailorgarmentsのAI採寸機能で、正面写真の撮影を案内する画面', width: 1240, height: 2658 },
      { src: './assets/images/works/tailorgarments-product-options.png', alt: 'Tailorgarmentsの商品詳細と、AI採寸・サイズなどの選択画面', width: 4124, height: 2326 },
    ],
  },
  { id: 'photo-weddingbox', preview: './assets/mov/photo-weddingbox-scroll-960-20261023.webm', showcaseVideo: true, name: 'Photo weddingbox', category: 'Web / WordPress', image: './assets/images/photo-weddingbox.webp', href: 'https://photo-weddingbox.com/', description: 'デザイン・ディレクション・WordPress構築・ドレス比較機能の実装など', featured: true,
    detail: 'お気に入りに登録したドレスを比較できる機能などを実装しています。',
    screenshots: [
      { src: './assets/images/works/photo-weddingbox-dress-comparison.png', alt: 'Photo weddingboxのドレス一覧と、お気に入りの登録・比較機能', width: 1511, height: 981 },
    ],
  },
  { id: 'kanaka', preview: './assets/mov/kanaka-scroll-960-20261023.webm', showcaseVideo: true, name: 'KANAKA VILLAGE', image: './assets/images/works/kanaka.png', imageWidth: 1920, imageHeight: 1254, industry: 'ホテル・宿泊施設', category: 'Web / WordPress', href: 'https://www.kanaka-village.com/', description: 'ディレクション・UI/UX・デザイン・実装' },
  { id: 'isea', preview: './assets/mov/isea-scroll-960-20261023.webm', showcaseVideo: true, name: 'ISEA Clinic', image: './assets/images/works/isea.png', imageWidth: 1512, imageHeight: 982, industry: '美容クリニック', category: 'Web / WordPress', href: 'https://www.tokyoisea.com/', description: 'ディレクション・UI/UX・デザイン・実装' },
  { id: 'honolulu', preview: './assets/mov/honolulu-scroll-400.webm', name: 'ホノルル工務店', image: './assets/images/works/honolulu.png', imageWidth: 1515, imageHeight: 981, industry: '建築', category: 'Web', href: 'https://real-group.jp/honolulu/', description: 'デザイン・ディレクション・コーディング' },
  { id: 'mmdr', preview: './assets/mov/mmdr-scroll-960-20261023.webm', showcaseVideo: true, name: 'みなとみらいダイナソーラリー2026', image: './assets/images/works/mmdr.png', imageWidth: 442, imageHeight: 694, industry: 'イベント', category: 'Web / イベント', href: 'https://www.mmdr.jp/', description: 'デザイン・ディレクション・コーディング' },
  { id: 'cinema-gourmet-2026', name: 'みなとみらい シネマ＆グルメラリー2026', image: './assets/images/works/cinema-gourmet-2026.png', imageWidth: 439, imageHeight: 817, industry: 'イベント', category: 'Web / イベント', href: 'https://minatomirai21.com/sp/cinema-gourmet-2026', description: 'デザイン・ディレクション・コーディング' },
  { id: 'gstamprally2025', preview: './assets/mov/gstamprally2025-scroll-960-20261023.webm', showcaseVideo: true, name: 'みなとみらいグルメ★スタンプラリー', image: './assets/images/works/gstamprally2025.png', imageWidth: 1512, imageHeight: 982, industry: 'イベント', category: 'Web / イベント', href: 'https://minatomirai21.com/sp/gstamprally2025', description: 'デザイン・ディレクション・コーディング' },
  { id: 'double-doors', name: 'Double Doors 本店', image: './assets/images/works/double-doors.png', imageWidth: 1515, imageHeight: 981, industry: 'レストラン', category: 'Web', href: 'https://www.doubledoors.jp/', description: 'デザイン・ディレクション・コーディング' },
  { id: 'bosch-christmas-2025', name: 'ドイツクリスマスマーケット in 都筑 2025', image: './assets/images/works/bosch-christmas-2025.png', imageWidth: 1515, imageHeight: 981, industry: 'イベント', category: 'Web / イベント', href: 'https://bosch-forum-tsuzuki.com/christmas_2025/', description: 'デザイン・ディレクション・コーディング' },
  { id: 'double-doors-navy', name: 'Double Doors NAVY', image: './assets/images/works/double-doors-navy.png', imageWidth: 1515, imageHeight: 981, industry: 'レストラン', category: 'Web', href: 'https://doubledoors.jp/navy/', description: 'デザイン・ディレクション・コーディング' },
  { id: 'ametohizasito', name: '雨と陽射しと', image: './assets/images/works/ametohizasito.png', imageWidth: 1512, imageHeight: 982, industry: 'リラクゼーションサロン', category: 'Web', href: 'https://ametohizasito.com/', description: 'デザイン・ディレクション・コーディング' },
  { id: 'take-na', preview: './assets/mov/take-na-scroll-960-20261023.webm', showcaseVideo: true, name: '小笠原エコツーリズムリゾート', image: './assets/images/works/take-na.png', imageWidth: 1512, imageHeight: 982, industry: 'ホテル・ガイド・カフェ', category: 'Web', href: 'https://take-na.com/', description: 'デザイン・ディレクション・コーディング' },
  { id: 'yoshimura-kaitai', preview: './assets/mov/yoshimura-kaitai-scroll-960-20261023.webm', showcaseVideo: true, name: '吉村解体', image: './assets/images/works/yoshimura-kaitai.png', imageWidth: 1512, imageHeight: 982, industry: '自動車解体', category: 'Web', href: 'https://yoshimura-kaitai.co.jp/', description: 'デザイン・ディレクション・コーディング' },
  { id: 'innatus', name: 'INNATUS', image: './assets/images/works/innatus.png', imageWidth: 1512, imageHeight: 982, industry: '化粧品', category: 'Web', href: 'https://innatus.co.jp/', description: 'デザイン・ディレクション・コーディング' },
  { id: 'mowa', preview: './assets/mov/mowa-scroll-960-20261023.webm', showcaseVideo: true, name: 'MoWa.', image: './assets/images/works/mowa.png', imageWidth: 1512, imageHeight: 982, industry: 'トレーニング', category: 'Web', href: 'https://mowa-smc.com/', description: 'デザイン・ディレクション・コーディング' },
  { id: 'tsudouie', name: 'TSUDOUIE', image: './assets/images/works/tsudouie.png', imageWidth: 1512, imageHeight: 982, industry: '建築', category: 'Web', href: 'https://real-group.jp/tsudouie/', description: 'デザイン・ディレクション・コーディング' },
  { id: 'tenshoin', preview: './assets/mov/tenshoin-scroll-960-20261023.webm', showcaseVideo: true, name: '天照院', image: './assets/images/works/tenshoin.png', imageWidth: 1512, imageHeight: 982, industry: '寺院', category: 'Web', href: 'https://tenshoin-singon.net/', description: 'デザイン・ディレクション・コーディング' },
];
